export default __webpack_public_path__ + "static/media/temporarySnap.1215b057.svg";